import type { TagSimulacaoProps } from "./types-tag-simulacao";
import { TagSimulacaoView } from "./view-tag-simulacao";

/** Tag "Simulação" do cabeçalho dos modais abertos no Modo Simulação (Figma: tag-simulacao). */
export function TagSimulacao(props: TagSimulacaoProps) {
  return <TagSimulacaoView {...props} />;
}

export type * from "./types-tag-simulacao";
